import { tracked } from "@glimmer/tracking";
import { modifier } from "ember-modifier";

/**
 * Keeps a reference to a DOM element of the template.
 *
 * ```gts
 * section = new ElementRef();
 *
 * <section tabindex='-1' {{this.section.register}}>…</section>
 *
 * this.section.element?.focus();
 * ```
 */
export default class ElementRef<E extends Element = HTMLElement> {
  @tracked element?: E;

  register = modifier((element: E) => {
    this.element = element;

    return () => {
      this.element = undefined;
    };
  });
}
